import React from 'react';
import colors from "../../styles/colors";


const content = `<g fill="#6E6E6E">
  <path fill="${colors.primary}" d="M0,14.49H38.58L68.36,67.19a417.54,417.54,0,0,1,23.79,49.29h.64C90.65,97.5,90,78.08,90,56.31V14.49h30v144H85.77L54.55,102.73C45.94,87,36.25,68.5,29.36,51.49h-.86C29.57,70.65,30,91.31,30,115v43.49H0Z"/>
  <path d="M177,53.49h33v105H177Z"/>
  <path d="M266,6.49h33v60h.43a37.05,37.05,0,0,1,29.85-15c20.82,0,36.72,14.34,36.72,46v61H333V100.85c0-13.71-4.67-23.14-16.79-23.14-8.5,0-13.81,5.57-16.15,11.36A27.41,27.41,0,0,0,299,96.36v62.13H266Z"/>
  <path d="M476,88.37v-1.5c.44-5.57-2.56-13.5-18.85-13.5-10.71,0-21.64,3.86-28.71,7.93l-6-20.79c7.29-4.29,21.64-9.43,40.71-9.43,34.93,0,45.86,20.57,45.85,45.21v36.43a167.29,167.29,0,0,0,1.72,25.77H481.37l-1.93-10h-.64c-6.86,7.58-17.57,12.08-30,12.08-21.21,0-33.86-15.21-33.86-31.93C415,101.22,439.37,88.37,476,88.37Zm-15.35,49.28a17.72,17.72,0,0,0,16.71-12,14.74,14.74,0,0,0,.64-5.36V108.51c-17.36.21-30.43,4.29-30.43,16.71C447.58,133.58,453.15,137.65,460.65,137.65Z"/>
  <path d="M614.87,51.08c31.5,0,53.57,21,53.57,54.64,0,39.21-30,54.86-56.14,54.86-30,0-53.36-20.14-53.36-54.64C559,70.58,584,51.08,614.87,51.08Zm-1.07,86.41c14.14,0,21-13.93,21-31.07,0-14.78-5.14-31.93-21-31.93-16.07,0-21.21,17.14-21.21,31.71,0,16.72,6.85,31.29,21.2,31.29Z"/>
  <path d="M230,45.2a6.49,6.49,0,0,0-4.34-6.1V16.63L230,14.85,193,0,156,14.85l37,14.85,28.33-11.32V39.09a6.47,6.47,0,0,0-.62,12l-3.6,10.81,4.11,1.37,2.28-6.84,2.28,6.84,4.11-1.37L226.29,51A6.49,6.49,0,0,0,230,45.2Z"/>
  <path d="M193,34.36l-19.51-7.83v5.66C173.49,38.37,181.88,43,193,43s19.51-4.66,19.51-10.84V26.53Z"/>
</g>`;

export default function Logo() {

    return <svg
        className="logo"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 669 161"
        preserveAspectRatio="xMidYMid"
        dangerouslySetInnerHTML={{__html: content}}
    />;
}
